<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item
        v-for="(item, index) in pageMeta.breadcrumb"
        :key="index"
      >
        <router-link :to="{ name: item.name }">{{ item.title }}</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>{{ pageMeta.title }}</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      {{pageMeta.title}}
      <div class="title-btn">
      </div>
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="下载模板">
            <el-button @click="download">下载模板</el-button>
          </el-form-item>
          <el-form-item label="上传文件">
            <el-upload
              style="margin-bottom:20px;"
              drag
              :limit="1"
              class="upload-demo"
              ref="upload"
              :action="`${$axios.defaults.baseURL}admin/email/importEmail`"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :on-success="onSuccess"
              accept=".xls,.docx,.docm,.dotm,.xlsx,.xlsm,.xltx,.xltm,.xlsb,.xlam,.docx,.xlsx,.xlsm,.xltx"
              :auto-upload="false">
<!--              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>-->
              <i class="el-icon-upload up-box"></i>
              <p class="upHint">
                点击或拖拽到此处上传
              </p>
            </el-upload>
            <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传</el-button>
            <el-button
              style="margin-left: 10px;"
              size="small" type="danger"
              @click="downloadErrorData"
              v-if="error">下载错误数据</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { exportTemplate } from '@/api/export';
  export default {
    name: "BatchOperation",
    beforeCreate() {
      this.pageMeta = this.$route.meta;
      // this.email_client_id = this.$route.params.id;
    },
    data: () => ({
      fileList:[],
      form:{},
      error:false,
    }),
    methods:{
      download(){
        exportTemplate();
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      //上传成功回调
      onSuccess(res, file, fileList) {
        if(res.status == 0){
          this.$message({
            message: '上传成功！',
            type: 'success'
          });
          this.error = false;
        }else if(res.status == 1){
          this.error_path = 'api/' + res.data.error_path;
          this.$message.error('模板内容有误，请下载错误表格！');
          this.error = true;
        }else{
          this.$message.error(res.msg);
          this.error = false;
        }
        this.fileList = [];
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
      downloadErrorData() {
        window.location.href = this.error_path;
      }

    }
  }
</script>

<style scoped>
  .upHint{
    font-size: 16px;
    margin: 0 0 4px;
    color: #adadad!important;
    font-weight: 400;
  }

  .upload-area>.el-upload{
    width: 100%;
  }
  .up-box{
    font-size: 40px;
    color: #FD8E02;
    line-height: 0;
  }
</style>